import React from "react";
import styled from "@emotion/styled";
import { keyframes } from "@emotion/react";
import { Modal, Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: scale(1);
  }
  to {
    opacity: 0;
    transform: scale(0.95);
  }
`;

const StyledModal = styled(Modal)`
  .ant-modal-content {
    border-radius: 16px;
    overflow: hidden;
    animation: ${(props) => (props.isClosing ? fadeOut : fadeIn)} 0.3s
      ease-in-out;
  }

  .ant-modal-header {
    border-bottom: none;
    padding: 24px 24px 0;
  }

  .ant-modal-body {
    padding: 24px;
  }

  .ant-modal-footer {
    border-top: none;
    padding: 0 24px 24px;
  }
`;

const ModalContent = styled.div`
  text-align: center;
`;

const IconWrapper = styled.div`
  margin-bottom: 24px;

  .anticon {
    font-size: 48px;
    color: #ff4d4f;
  }
`;

const Title = styled.h2`
  font-size: 24px;
  font-weight: 600;
  color: #1d2433;
  margin-bottom: 16px;
`;

const Description = styled.p`
  font-size: 16px;
  color: #666;
  margin-bottom: 24px;
  line-height: 1.5;
`;

const PlanInfo = styled.div`
  background: #f9f9f9;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 24px;
  display: flex;
  align-items: center;
  gap: 12px;
`;

const PlanIcon = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 24px;
    height: 24px;
  }
`;

const PlanName = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #1d2433;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

const CancelSubscriptionModal = ({
  isOpen,
  onConfirm,
  onClose,
  planName,
  planIcon,
  isClosing,
}) => {
  return (
    <StyledModal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={480}
      isClosing={isClosing}
    >
      <ModalContent>
        <IconWrapper>
          <ExclamationCircleOutlined />
        </IconWrapper>

        <Title>Cancel Subscription</Title>

        <Description>
          Are you sure you want to cancel your subscription? You'll lose access
          to all premium features.
        </Description>

        <PlanInfo>
          <PlanIcon>
            {planIcon ? (
              <img src={planIcon} alt={planName} />
            ) : (
              <ExclamationCircleOutlined
                style={{ fontSize: "24px", color: "#666" }}
              />
            )}
          </PlanIcon>
          <PlanName>{planName}</PlanName>
        </PlanInfo>

        <ButtonGroup>
          <Button
            onClick={onClose}
            size="large"
            style={{
              minWidth: "140px",
              height: "44px",
              borderRadius: "8px",
            }}
          >
            Keep Subscription
          </Button>
          <Button
            type="primary"
            danger
            onClick={onConfirm}
            size="large"
            style={{
              minWidth: "140px",
              height: "44px",
              borderRadius: "8px",
            }}
          >
            Cancel Subscription
          </Button>
        </ButtonGroup>
      </ModalContent>
    </StyledModal>
  );
};

export default CancelSubscriptionModal;
